import { GET_PAYMENT_DEMONSTRATIVE_COPAN, GET_PAYMENT_DEMONSTRATIVE_COPAN_LOGS } from 'store/constants'

export function generateDocsCopan(values) {
  return {
    type: GET_PAYMENT_DEMONSTRATIVE_COPAN,
    payload: values,
  }
}

export function getReportLogs(values) {
  return {
    type: GET_PAYMENT_DEMONSTRATIVE_COPAN_LOGS,
    payload: values,
  }
}